
const digest = '95bf7bf6b8b659c98b0fc6090e05552c6ad1224e64405d6f6fafa9cd3d299d80';
const classes = {"wrapper":"_wrapper_1hmia_1","buttonWrapper":"_buttonWrapper_1hmia_7"};
const css = `._wrapper_1hmia_1 {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

._buttonWrapper_1hmia_7 {
  display: flex;
  justify-content: flex-end;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  